module.exports = __webpack_public_path__ + "652437fba3300af9f60ed135e7d8ef28.ttf";